// extracted by mini-css-extract-plugin
export default {"row":"styles_row__U2G3Q","debug":"styles_debug__HuOCa","lastRowBottomBorder":"styles_lastRowBottomBorder__dEdr2","removeBorderTop":"styles_removeBorderTop__SPngN"};